import { useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import ProvisionErrorTableModalComponent from 'ProfileModule/components/ProvisionErrorTableModal';

type ModalProps = {
  teamId: number;
};

const useProvisionErrorTableModal = () => {
  const { openModal } = useDynamicModal();

  const handleOpenProvisionErrorTableModal = useCallback(
    (modalProps: { teamId: number }) => {
      openModal({
        modal: ({ toggle }) => (
          <ProvisionErrorTableModalComponent
            {...modalProps}
            isModalOpen
            toggleProvisionErrorTableModal={toggle}
          />
        ),
      });
    },
    [openModal],
  );

  return {
    handleOpenProvisionErrorTableModal,
  };
};

export default useProvisionErrorTableModal;
